var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.$store.getters.showSignup,
            expression: "$store.getters.showSignup"
          }
        ],
        staticClass: "sign-up",
        on: {
          click: function($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            _vm.close($event)
          }
        }
      },
      [
        _c("div", { staticClass: "sign-up-container" }, [
          _c("div", { staticClass: "container-left" }, [
            _c("div", { staticClass: "bg-img" }, [
              _vm.lang !== "zh-CN"
                ? _c("img", {
                    attrs: {
                      src: require("../../../assets/images/ebbly-login.png"),
                      alt: ""
                    }
                  })
                : _c("img", {
                    attrs: {
                      src: require("../../../assets/images/ebbly-login-cn.png"),
                      alt: ""
                    }
                  })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-right" }, [
            _c("div", { staticClass: "form" }, [
              _c("p", { staticClass: "form-header" }, [
                _c("i", {
                  staticClass: "iconfont icon-cancel",
                  on: { click: _vm.close }
                })
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "sign-up-title" }, [
                _vm._v(_vm._s(_vm.$t("signup")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      attrs: { stretch: true },
                      model: {
                        value: _vm.signupType,
                        callback: function($$v) {
                          _vm.signupType = $$v
                        },
                        expression: "signupType"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: _vm.$t("email"), name: "1" } },
                        [_c("i-email")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: _vm.$t("mobile_text"), name: "2" } },
                        [_c("i-phone")],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "footer-tips" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("register_has_ebbly_account")))
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "btn-text", on: { click: _vm.showLogin } },
                [_vm._v(_vm._s(_vm.$t("login_upper")))]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39b4391d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39b4391d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Public/SignUp/Index.vue
// module id = null
// module chunks = 